import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { Feature, LineString } from 'geojson'
import { MapBoxDrawEnum } from '../enums/MapBoxDrawMode.enum'

export class MapProvider {
	static clearLineString(draw?: MapboxDraw) {
		if (!draw) return

		const lineString = draw
			.getAll()
			.features.find((feature) => feature.geometry.type === 'LineString') as Feature<LineString>

		if (draw.getMode() !== MapBoxDrawEnum.DRAW_LINE_STRING && lineString) {
			draw.delete(lineString.id as string)
		}
	}
}
